var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "rate-feedback" },
      on: {
        keyup: function($event) {
          $event.stopPropagation()
        },
        keydown: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          attrs: {
            id: "rate-area",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: _vm.$t("rate")
          }
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "ms-windows-store://review/?ProductId=9NN76P3B5D8G"
              },
              on: { mousedown: _vm.rateDown }
            },
            [_vm._v("❤")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: {
            id: "feedback-area",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: _vm.$t("feedback")
          }
        },
        [
          _c(
            "a",
            {
              attrs: {
                "data-toggle": "modal",
                "data-target": "#feedback-dialog" + _vm.dialogTag
              },
              on: { mousedown: _vm.feedbackShow }
            },
            [_vm._v("✉")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "feedback-dialog" + _vm.dialogTag }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _c("label", { attrs: { for: "comment" } }, [
                  _vm._v(_vm._s(_vm.$t("content")))
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.comment,
                      expression: "comment"
                    }
                  ],
                  attrs: { id: "comment" },
                  domProps: { value: _vm.comment },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.comment = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "email" } }, [
                  _vm._v(_vm._s(_vm.$t("email")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  attrs: { id: "email", type: "email" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.feedback }
                  },
                  [_vm._v(_vm._s(_vm.$t("submit")))]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }